import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
import {
  Dic
} from '$utils'
export const tableOption = function (staffShow, operateShow) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '120px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: '400px',
    viewDialogWidth: '850px',
    viewDialogHeight: 500,
    emptyText: i18n.t('carAuthority.title.noData'),
    column: [{
        label: '车牌号',
        prop: 'plateCode',
        align: 'right',
        search: true,
        addDisplay: false,
        editDisplay: false,
        editDisabled: false,
        viewDisplay: true,
        overHidden: true,
        rules: [{
          required: true,
          message: '请输入车牌号',
          trigger: 'blur'
        }]
      },
      {
        label: '车主',
        prop: 'name',
        align: 'right',
        hide: false,
        search: true,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        span: 12,
        rules: [{
          required: true,
          message: '请输入车主姓名',
          trigger: 'blur'
        }]
      },
      {
        label: '车主类型',
        prop: 'personnelType',
        align: 'right',
        type: "select",
        hide: false,
        search: true,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        span: 12,
        rules: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }],
        dicData: [{
            label: '员工',
            value: '1',
          },
          {
            label: '访客',
            value: '2',
          },
        ],
        viewFormatter: (row, value) => {
          switch (Number(value)) {
            case 1:
              value = '员工'
              break;
            case 2:
              value = '访客'
              break;
            default:
              break;
          }
          return value
        },
        formatter: (row, value) => {
          switch (Number(value)) {
            case 1:
              value = '员工'
              break;
            case 2:
              value = '访客'
              break;
            default:
              break;
          }
          return value
        },
      },
      {
        label: '手机号',
        prop: 'phone',
        hide: false,
        search: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        rules: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
      },
      {
        label: '车牌类型',
        prop: 'plateType',
        type: 'select',
        hide: true,
        search: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车牌类型',
        rules: [{
          required: true,
          message: '请输入车牌类型',
          trigger: 'blur'
        }],
        dicData: Dic.find('SENU041'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU041', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU041', value) : ''
        },
      },
      {
        label: '车牌颜色',
        prop: 'plateColor',
        type: 'select',
        search: false,
        searchSlot: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车牌颜色',
        rules: [{
          required: true,
          message: '请输入车牌颜色',
          trigger: 'blur'
        }],
        dicData: Dic.find('SENU040'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU040', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU040', value) : ''
        },
      },
      {
        label: '车辆类型',
        prop: 'vehicleType',
        type: 'select',
        search: false,
        hide: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车辆类型',
        dicData: Dic.find('SENU038'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU038', Number(value))
          }
          return ''
        },
        rules: [{
          required: true,
          message: '请输入车辆类型',
          trigger: 'blur'
        }],
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU038', value) : ''
        },
      },
      {
        label: '车辆颜色',
        prop: 'vehicleColor',
        type: 'select',
        hide: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请输入车辆颜色',
        rules: [{
          required: true,
          message: '请输入车辆类型',
          trigger: 'blur'
        }],
        dicData: Dic.find('SENU039'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU039', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU039', value) : ''
        },
      },
      {
        label: '通行生效时间',
        prop: 'effectiveTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 24,
        viewSpan: 12,
        rules: [{
          required: true,
          message: "请选择通行生效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        viewFormatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
      {
        label: '通行失效时间',
        prop: 'expirationTime',
        value: '',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 24,
        viewSpan: 12,
        rules: [{
          required: true,
          message: "请选择通行失效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        viewFormatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
      {
        label: '车辆道闸名称',
        prop: 'thirdDeviceName',
        align: 'right',
        hide: false,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        span: 12,
      },
      {
        label: '授权',
        prop: 'authStatus',
        type: 'select',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        dicData: [{
            label: '失效',
            value: '2'
          },
          {
            label: '已授权',
            value: '1'
          }
        ],
      },
      {
        label: '授权时间',
        prop: 'createTime',
        value: '',
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        columnWidth: '150px',
        span: 12,
        rules: [{
          required: true,
          message: "请选择通行失效时间",
          trigger: "blur",
        }, ],
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        viewFormatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
      {
        label: '授权渠道',
        prop: 'authChannel',
        search: false,
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
        dicData: Dic.find('SENU104001'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU104001', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU104001', value) : ''
        },
      },
      {
        label: '授权人',
        prop: 'creatorName',
        search: false,
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
      },
      {
        label: '授权时间',
        prop: 'passageTime',
        type: 'datetimerange',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: true,
        hide: true,
        valueFormat: 'timestamp',
        span: 12,
        align: 'center',
      },
    ]
  }
}